import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import FormattedListValue from '@/shared/components/FormattedListValue';
import SimplePanel from '@/shared/components/SimplePanel';
import Checkbox from '@/shared/components/input/Checkbox';
import utils, { minutesToTimeSpan } from '@/shared/utils/adminpulse';
import messages from '../jobMessages';

// Shared detail for both SetDeviationExecutionDuration and ResetDeviationExecutionDuration jobs.
const JobDetailUpdateDeviationDuration = ({ job }) => {
  const parameters = utils.toCamel(job.parameters);
  const subtaskTemplateIds = parameters.subtaskTemplateIds || [];

  return (
    <SimplePanel title={<FormattedListValue list="jobType" id={job.jobType} />}>
      <div className="info-block container-fluid radius4B">
        <div className="row">
          <div className="col-md-3 col-sm-4">
            <label>
              <b>
                <FormattedMessage {...messages.TaskTemplate} />
              </b>
            </label>
          </div>
          <div className="col-md-9 col-sm-8">
            <FormattedListValue
              list="tasktemplate"
              id={parameters.mainTaskTemplateId}
              fallback=""
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-3 col-sm-4">
            <label>
              <b>
                <FormattedMessage {...messages.Subtask} />
              </b>
            </label>
          </div>
          <div className="col-md-9 col-sm-8">
            {parameters.includeMainTask ? (
              <FormattedMessage {...messages.OnlyMainTask} />
            ) : (
              subtaskTemplateIds.map(id => (
                <div key={id}>
                  <FormattedListValue list="tasktemplate" id={id} fallback="" />
                </div>
              ))
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-md-3 col-sm-4">
            <label>
              <b>
                <FormattedMessage {...messages.ExecutionDuration} />
              </b>
            </label>
          </div>
          <div className="col-md-9 col-sm-8">
            {parameters.reset ? (
              <FormattedMessage {...messages.ResetToTemplateValue} />
            ) : (
              minutesToTimeSpan(parameters.executionDuration || 0)
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-md-3 col-sm-4">
            <label>
              <b>
                <FormattedMessage {...messages.ApplyToTaskboard} />
              </b>
            </label>
          </div>
          <div className="col-md-9 col-sm-8">
            <Checkbox value={!!parameters.propagate} onClick={() => {}} />
          </div>
        </div>
      </div>
    </SimplePanel>
  );
};

JobDetailUpdateDeviationDuration.propTypes = {
  job: PropTypes.shape({}).isRequired,
};

export default injectIntl(JobDetailUpdateDeviationDuration);
